import { Alert } from "@heroui/react";

export const Inhibit = () => {
  return <Alert color="danger">Logging in is disabled</Alert>;
};
